import SnapSummaryLogo from './assets/melns1.png';
import TeamCheckLogo from './assets/white_orange.png';
import GramatpilotsLogo from './assets/icon.svg';
import WinDailyLogo from './assets/windaily_optimised.png';
import SkyFluxLogo from './assets/skyflux-black.png';
import HealthRecordsLogo from './assets/healthrecords-logo.png';

import SnapSummaryGif from './assets/snapsummary-short.gif';
import TeamCheckGif from './assets/teamcheck-short.gif';
import GramatpilotsGif from './assets/gramatpilots-short.gif';
import WinDailyGif from './assets/windaily-short.gif';
import SkyFluxGif from './assets/skyflux.gif';
import HealthRecordsGif from './assets/healthrecords-short.gif';

export const PROJECTS = [
  {
    id: 'teamcheck',
    index: '01',
    title: 'TeamCheck',
    tagline: 'Attendance, handled.',
    description:
      'The #1 attendance management tool for coaches, event organizers, and casual gatherings. Track who shows up, nudge who doesn’t, and run your team without spreadsheets.',
    tags: ['Mobile', 'iOS', 'Android', 'SaaS'],
    url: 'https://www.teamcheck.co',
    status: 'live',
    accent: '#ff6b2c',
    logo: TeamCheckLogo,
    gif: TeamCheckGif,
  },
  {
    id: 'skyflux',
    index: '02',
    title: 'SkyFlux',
    tagline: 'Drone swarms at scale.',
    description:
      'Affordable AI-powered drone swarm technology delivering coordinated autonomous operations at scale — from inspection to search and rescue.',
    tags: ['Drones', 'AI', 'Autonomy'],
    url: null,
    status: 'archived',
    accent: '#4cc9f0',
    logo: SkyFluxLogo,
    gif: SkyFluxGif,
  },
  {
    id: 'healthrecords',
    index: '03',
    title: 'Health Records',
    tagline: 'Your health, one timeline.',
    description:
      'Track injuries, manage medications, and share your complete health timeline with doctors — all in one beautifully simple app.',
    tags: ['Mobile', 'Health', 'iOS'],
    url: 'https://healthrecords.online',
    status: 'live',
    accent: '#34d399',
    logo: HealthRecordsLogo,
    gif: HealthRecordsGif,
  },
  {
    id: 'snapsummary',
    index: '04',
    title: 'SnapSummary',
    tagline: 'Property photos into stories.',
    description:
      'Turned property images into captivating listings instantly. The ultimate tool for real estate agents and property owners — point, shoot, publish.',
    tags: ['AI', 'Real Estate', 'Web'],
    url: null,
    status: 'archived',
    accent: '#a78bfa',
    logo: SnapSummaryLogo,
    gif: SnapSummaryGif,
  },
  {
    id: 'gramatpilots',
    index: '05',
    title: 'Grāmatpilots',
    tagline: 'Bookkeeping on autopilot.',
    description:
      'Forget manual data entry — automated invoice capture and bookkeeping for Latvian businesses. Receipts in, clean books out.',
    tags: ['AI', 'Fintech', 'OCR'],
    url: null,
    status: 'archived',
    accent: '#60a5fa',
    logo: GramatpilotsLogo,
    gif: GramatpilotsGif,
  },
  {
    id: 'windaily',
    index: '06',
    title: 'Win Daily',
    tagline: 'Celebrate every win.',
    description:
      'A mobile app with personalized nudges to help you achieve your goals. A tool that cares, expects effort, and celebrates like your #1 fan.',
    tags: ['Mobile', 'Habits', 'iOS'],
    url: null,
    status: 'archived',
    accent: '#fbbf24',
    logo: WinDailyLogo,
    gif: WinDailyGif,
  },
];

